const activateSunoireLook = (story, target, options = {}) => {
  if (!story || !target) return;

  story.querySelectorAll('[data-sunoire-look-button]').forEach((button) => {
    const isActive = button.getAttribute('data-sunoire-look-button') === target;

    button.classList.toggle('is-active', isActive);
    button.setAttribute('aria-pressed', isActive ? 'true' : 'false');
  });

  story.querySelectorAll('[data-sunoire-look-item]').forEach((item) => {
    const isActive = item.getAttribute('data-sunoire-look-item') === target;
    const expanded = item.querySelector('.sunoire-story-looklist__expanded');

    item.classList.toggle('is-active', isActive);
    item.setAttribute('aria-current', isActive ? 'true' : 'false');
    item.setAttribute('aria-expanded', isActive ? 'true' : 'false');

    if (expanded) {
      expanded.setAttribute('aria-hidden', isActive ? 'false' : 'true');
    }
  });

  if (options.scroll !== false) {
    story.querySelector(`[data-sunoire-look-item="${target}"]`)?.scrollIntoView({
      block: 'nearest',
      inline: 'nearest',
      behavior: 'smooth',
    });
  }
};

document.addEventListener('click', (event) => {
  const lookButton = event.target.closest('[data-sunoire-look-button]');

  if (lookButton) {
    const story = lookButton.closest('[data-sunoire-editorial-section]');
    const target = lookButton.getAttribute('data-sunoire-look-button');

    activateSunoireLook(story, target);
    return;
  }

  const lookItem = event.target.closest('[data-sunoire-look-item]');

  if (lookItem && !event.target.closest('a')) {
    const story = lookItem.closest('[data-sunoire-editorial-section]');
    const target = lookItem.getAttribute('data-sunoire-look-item');

    activateSunoireLook(story, target, { scroll: false });
    return;
  }

  const button = event.target.closest('[data-sunoire-tab-button]');

  if (!button) return;

  const tabs = button.closest('[data-sunoire-tabs]');
  if (!tabs) return;

  const target = button.getAttribute('data-sunoire-tab-button');

  tabs.querySelectorAll('[data-sunoire-tab-button]').forEach((tabButton) => {
    const isActive = tabButton === button;
    tabButton.classList.toggle('is-active', isActive);
    tabButton.setAttribute('aria-selected', isActive ? 'true' : 'false');
  });

  tabs.querySelectorAll('[data-sunoire-tab-panel]').forEach((panel) => {
    const isActive = panel.getAttribute('data-sunoire-tab-panel') === target;
    panel.classList.toggle('is-active', isActive);
    panel.hidden = !isActive;
  });

  // Point the section's "View all" link at the active category's collection page.
  const viewAllHref = button.getAttribute('data-view-all');
  if (viewAllHref) {
    const scope = button.closest('.sunoire-product-discovery') || tabs;
    scope.querySelectorAll('.sunoire-product-discovery__view-all, [data-sunoire-view-all]').forEach((link) => {
      link.setAttribute('href', viewAllHref);
    });

    const viewAllLabel = button.getAttribute('data-view-all-label');
    if (viewAllLabel) {
      scope.querySelectorAll('[data-sunoire-view-all-label]').forEach((el) => {
        el.textContent = viewAllLabel;
      });
    }
  }
});

// Arrow-key navigation between tabs (any [data-sunoire-tabs] with role=tab buttons).
document.addEventListener('keydown', (event) => {
  if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;

  const current = event.target.closest('[role="tab"][data-sunoire-tab-button]');
  if (!current) return;

  const tabs = current.closest('[data-sunoire-tabs]');
  if (!tabs) return;

  const all = Array.from(tabs.querySelectorAll('[role="tab"][data-sunoire-tab-button]'));
  const index = all.indexOf(current);
  const next = event.key === 'ArrowRight' ? all[(index + 1) % all.length] : all[(index - 1 + all.length) % all.length];

  event.preventDefault();
  next.focus();
  next.click();
});

document.addEventListener('keydown', (event) => {
  if (event.key !== 'Enter' && event.key !== ' ') return;

  const lookItem = event.target.closest('[data-sunoire-look-item]');

  if (!lookItem || event.target.closest('a')) return;

  event.preventDefault();

  const story = lookItem.closest('[data-sunoire-editorial-section]');
  const target = lookItem.getAttribute('data-sunoire-look-item');

  activateSunoireLook(story, target, { scroll: false });
});
